
// ! rename the function to align with the widget name
export const sonataControlData = (data) => {
    const el = document.querySelector('.curious-sonata-control-data');
    if (!el) return;

    // ------------------------------------------------------------
   const metaContainer = el.querySelector('.meta-container');
    const html = data.info.map(item => {
        if(item.value) {
            return `
            <div class="meta">
                <strong>${item.label}: </strong>
                <span>${item.value}</span>
            </div>
            `
        }
    }).join('');
    metaContainer.innerHTML = html;


    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

